import { render, staticRenderFns } from "./cell-renderer-pax.vue?vue&type=template&id=3b429744"
import script from "./cell-renderer-pax.vue?vue&type=script&lang=js"
export * from "./cell-renderer-pax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports